module.exports = __webpack_public_path__ + "img/classic_1.1be8c49e.png";